module.exports = "<div [formGroup]=\"formGroup\" class=\"radio-input\">\r\n  <mat-radio-group [formControlName]=\"widget.param\">\r\n    <mat-radio-button [value]=\"value.value\" *ngFor=\"let value of widget.values\">\r\n      <span class=\"wrap-mat-radio-label\" [innerHtml]=\"value.label\">\r\n      </span>\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/form/radio-input/radio-input.component.html
// module id = ../../../../../src/app/components/form/radio-input/radio-input.component.html
// module chunks = main